/**
 * @graph-stack product-innovation-lab
 * @graph-domain UX
 * @graph-business ヘッダー・サイドバーを出さずにページだけを描くパスかを判定する（基本設計の図の全画面表示）
 * @graph-connects none
 */

/**
 * 基本設計の図を全画面で開くパス（`/projects/bd/{bdKey}/graph`）。
 * @graph-connects none
 */
const BD_GRAPH_PATH = /^\/projects\/bd\/[^/]+\/graph\/?$/;

/**
 * AppShell（ヘッダー・サイドバー）で包まずにページだけを描くパスか。
 * 図を新しいタブで開いたときに画面を図だけに使うためのもので、認証のゲートは通常どおり通す。
 *
 * @param pathname - 現在のパス
 * @returns 包まずに描くなら true
 * @graph-connects none
 */
export function isBareLayoutPath(pathname: string): boolean {
  return BD_GRAPH_PATH.test(pathname);
}
